import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import ServicePage from "./components/ServicePage";
import ContactPage from "./components/ContactPage";
import Services from "./components/Services";
import ServicePartners from "./components/ServicePartners";
import PartnerProfile from "./components/PartnerProfile";
import CustomerProfile from "./components/CustomerProfile";
import PartnerDetail from "./components/PartnerDetail";
import BookingPage from "./components/BookingPage";
import LoginModal from "./components/LoginModal";
import SignupModal from "./components/SignupModal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);

  return (
    <BrowserRouter>
      <Header
        openLogin={() => setLoginOpen(true)}
        openSignup={() => setSignupOpen(true)}
      />

      {/* ROUTES */}
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Home />
              {/* <Services /> */}
            </>
          }
        />

        {/* ABOUT US PAGE */}
        <Route path="/about-us" element={<AboutUs />} />

        {/* SERVICES PAGE */}
        <Route path="/services" element={<ServicePage />} />

        {/* CONTACT PAGE */}
        <Route path="/contact" element={<ContactPage />} />

        {/* SERVICE → PARTNER LIST */}
        <Route path="/service/:serviceName" element={<ServicePartners />} />

        {/* PARTNER DETAIL */}
        <Route path="/partner/:id" element={<PartnerDetail />} />

        {/* BOOKING */}
        <Route path="/book/:id" element={<BookingPage />} />

        {/* PROFILES */}
        <Route path="/partner-profile" element={<PartnerProfile />} />
        <Route path="/customer-profile" element={<CustomerProfile />} />
      </Routes>

      {/* LOGIN MODAL */}
      {loginOpen && (
        <LoginModal
          close={() => setLoginOpen(false)}
          openSignup={() => {
            setLoginOpen(false);
            setSignupOpen(true);
          }}
        />
      )}

      {/* SIGNUP MODAL */}
      {signupOpen && (
        <SignupModal
          close={() => setSignupOpen(false)}
          openLogin={() => {
            setSignupOpen(false);
            setLoginOpen(true);
          }}
        />
      )}

      <Footer />
    </BrowserRouter>
  );
}

export default App;
